import React, { Component } from 'react';

class Search extends Component {
  state = { petQuery: '' };

  // Tracking the keypresses
  updatePetQuery = event => {
    console.log(event.target.value);
    this.setState({ petQuery: event.target.value });
  }

  // Activating search when 'Enter' is pressed
  handleKeyDown = event => {
    if (event.key === 'Enter') {
      this.searchPet();
    }
  }

  // Submitting the entered query to the state
  searchPet = () => {
    this.props.searchPet(this.state.petQuery);
  }

  render() {
    return (
      <div className='container-fluid text-center pb-5'>
        <div className='row row-cols-lg-auto align-items-center justify-content-center'>
          <div className="col-10 col-lg-4 p-0 mb-2 mb-lg-0">
            <input className='form-control' type='text' placeholder='Search by zip code or "city, state"' onChange={this.updatePetQuery} onKeyDown={this.handleKeyDown} />
          </div>
          <div className="col-12 p-0">
            <button type='button' className='btn btn-primary' onClick={this.searchPet}>Search</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Search;